import { lazy } from "react";
import { Route } from "react-router-dom";

const EkoPartnersHubLanding = lazy(() => import("./pages/WeeekoPartnersHubLanding.jsx"));
const ApplicationForm = lazy(() => import("./pages/ApplicationForm.jsx"));
const ThankYou = lazy(() => import("./pages/ThankYou.jsx"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy.jsx"));
const Blog = lazy(() => import("./pages/Blog.jsx"));

export default function PublicRoutes() {
  return (
    <>
      <Route path="/" element={<EkoPartnersHubLanding />} />
      <Route path="/apply" element={<ApplicationForm />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/blog" element={<Blog />} />
    </>
  );
}
